export default __webpack_public_path__ + "static/marketplace-908c7a2f868d2a0de4a5e5d1d7738311.png";